<!--================================
=            SIDEBARDUO            =
=================================-->
<template>
  <!-- app-drawer -->
  <v-navigation-drawer
    class="elevation-0"
    v-model="appConfig.model"
    :clipped="appConfig.clipped"
    :floating="appConfig.floating"
    :expand-on-hover="appConfig.expandOnHover"
    :permanent="appConfig.type === 'permanent'"
    :temporary="appConfig.type === 'temporary'"
    app
    overflow
    :color="appConfig.color"
  >
    <!-- logo app-drawer-left -->
    <div dark class="appDrawer__left">
      <div
        @click="goGroup(i, icon[0].name)"
        v-for="(icon, i) in menus"
        :class="{ active: path.group == icon[0].group }"
        :key="i"
        class="appDrawer__leftItem"
      >
        <div slot="activator">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon slot="activator" large color="white" v-on="on">{{ icon[0].action }}</v-icon>
            </template>
            <span>{{ _.capitalize(i) }}</span>
          </v-tooltip>
        </div>
        <div>
          <div class="appDrawer__lefttitle caption">{{_.capitalize(i)}}</div>
        </div>
      </div>
    </div>
    <!-- logo app-drawer-right -->
    <transition name="fade" mode="out-in" :color="appConfig.color" :class="{ active: isActive }">
      <div :color="appConfig.color" nav dense class="appDrawer__right scroll">
        <div class="appDrawer__logo flex">
          <img src="../../assets/img/logo11.png" />
        </div>
        <v-list>
          <v-list-item link>
            <v-list-item-content>
              <v-list-item-title
                style=" text-transform: capitalize;"
                class="appDrawer__right-header body-1 font-weight-bold"
              >{{ path.group }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">Lorem ipsum dolor sit.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list class="pa-2 ma-1 appDrawer__right" color="white" nav dense>
          <v-list-item-group v-bind:class="{ active: isActive }">
            <v-list-item
              class="appDrawer__right-item"
              @click="goPage(path.group, item.name)"
              v-for="item in menus[path.group]"
              :key="item.name"
              :color="item.active ? 'pink' : 'secondary'"
            >
              <v-list-item-content>
                <v-list-item-title
                  class="appDrawer__right-title body-2"
                  :class="{ 'font-weight-bold': path.sub == item.name }"
                >{{ _.startCase(item.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </transition>
  </v-navigation-drawer>
  <!-- app-drawer -->
</template>
<script>
export default {
  name: "sidebar-duo",

  data() {
    return {
      isActive: true,

      active: true,

      menus: {
        dashboard: [
          {
            name: "dashboard1",
            title: "Dashboard1",
            action: "ti-home",
            color: "pink",
            group: "dashboard"
          },

          {
            name: "dashboard2",
            title: "Dashboard2",
            action: "double_arrow",
            group: "dashboard"
          },
          {
            name: "dashboard3",
            title: "Dashboard3",
            action: "double_arrow",

            group: "dashboard"
          }
        ],

        charts: [
          {
            name: "apexcharts",
            action: "ti-email",
            title: "Apexcharts",
            color: "blue",
            group: "charts"
          },
          {
            name: "echarts",
            action: "mdi-celtic-cross",
            title: "Echarts",
            group: "charts"
          },
          {
            name: "chart-js",
            action: "mdi-celtic-cross",
            title: "ChartJs",
            group: "charts"
          },
          {
            name: "chartkick",
            action: "mdi-celtic-cross",
            title: "Chartkick",
            group: "charts"
          },

          {
            name: "morris",
            action: "mdi-celtic-cross",
            title: "Morris",
            group: "charts"
          },
          {
            name: "vue-organized",
            action: "mdi-celtic-cross",
            title: "vue-organized",
            group: "charts"
          },
          {
            name: "c3",
            title: "C3",
            action: "mdi-dna",
            group: "charts"
          },
          {
            name: "ricksaw",
            title: "Ricksaw",
            action: "mdi-hazard-lights",
            group: "charts"
          },
          {
            name: "nvd3",
            title: "Nvd3",
            action: "mdi-fruit-watermelon",
            group: "charts"
          }
        ],
        ui: [
          {
            name: "alert",
            title: "Alert",
            group: "ui",
            action: "ti-tag"
          },
          {
            name: "avatars",
            title: "Avatars",
            action: "loyalty",
            group: "ui"
          },
          {
            name: "banners",
            title: "Banners",
            action: "backup",
            group: "ui"
          },

          {
            name: "buttons",
            title: "Buttons",
            action: "opacity",
            group: "ui"
          },

          {
            name: "badges",
            title: "Badges",
            action: "backup",
            group: "ui"
          },

          {
            name: "collapsible",
            title: "Collapsible",
            action: "alarm",
            group: "ui"
          },

          {
            name: "cards",
            title: "Cards",
            action: "motorcycle",
            group: "ui"
          },

          {
            name: "carousels",
            title: "Carousels",
            action: "pets",
            group: "ui"
          },

          {
            name: "modals",
            title: "Modals",
            action: "recent_actors",
            group: "ui"
          },

          {
            name: "lists",
            title: "Lists",
            action: "videocam",
            group: "ui"
          },

          {
            name: "paginations",
            title: "Paginations",
            action: "control_camera",
            group: "ui"
          },

          {
            name: "progressbar",
            title: "Progressbar",
            action: "album",
            group: "ui"
          },
          {
            name: "tabs",
            title: "Tabs",
            action: "lock_open",
            group: "ui"
          },
          {
            name: "typography",
            title: "Typography",
            action: "watch_later",
            group: "ui"
          }
        ],
        ecommerce: [
          {
            name: "ecommerce-dashboard",
            title: "Dashboard",
            group: "ecommerce",
            action: "shopping_cart"
          },
          {
            name: "ecommerce-products",
            title: "Products",
            group: "ecommerce",
            action: "shopping_cart"
          },
          {
            name: "product-detail",
            title: "Products Detail",
            group: "ecommerce",
            action: "shopping_cart"
          },
          {
            name: "ecommerce-cart",
            title: "Cart",
            group: "ecommerce",
            action: "shopping_cart"
          },
          {
            name: "ecommerce-checkout",
            title: "Checkout",
            group: "ecommerce",
            action: "shopping_cart"
          }
        ],
        apps: [
          {
            action: "ti-clip",
            title: "Timeline",
            name: "timeline",
            group: "apps"
          },
          {
            action: "control_point",
            title: "Transitions",
            name: "transitions",
            group: "apps"
          },
          {
            action: "trending_flat",
            title: "Sweet Alert",
            name: "sweet-alert",
            group: "apps"
          },

          {
            action: "add_alert",
            title: "Treeviews",
            name: "treeviews",
            group: "apps"
          },
          {
            action: "mdi-flask-empty-outline",
            title: "Inbox",
            name: "inbox",
            group: "apps"
          },
          {
            action: "mdi-flask-empty-outline",
            title: "Read",
            name: "read",
            group: "apps"
          },
          {
            title: "Profile",
            name: "profile"
          },
          {
            title: "Blog",
            name: "blog",
            group: "apps"
          },
          {
            action: "today",
            title: "Calendar",
            name: "calendar",

            group: "apps"
          },

          {
            action: "mdi-laptop-windows",
            title: "Contacts",
            name: "contacts",
            group: "apps"
          },
          {
            title: "Invoice",
            name: "invoice",
            group: "apps",

            color: "teal"
          }
        ],
        forms: [
          {
            title: "Autocompletes",
            name: "autocompletes",
            group: "forms",
            action: "ti-settings"
          },
          {
            title: "Combobox",
            name: "combobox",
            group: "forms",
            action: "track_changes"
          },

          {
            title: "Textareas",
            name: "textareas",
            group: "forms",
            action: "favorite_border"
          },

          {
            title: "File Inputs",
            name: "file-inputs",
            group: "forms",
            action: "dashboard"
          },

          {
            title: "Forms Wizard",
            name: "wizard",
            group: "forms",
            action: "work"
          },
          {
            title: "Selects",
            name: "selects",
            group: "forms",
            action: "picture_in_picture"
          },
          {
            title: "Sliders",
            name: "sliders",
            group: "forms",
            action: "picture_in_picture"
          },
          {
            title: "Text Fields",
            name: "text-fields",
            group: "forms",
            action: "favorite_border"
          }
        ],
        pages: [
          {
            name: "ratings",
            group: "pages",
            action: "all_inbox",
            title: "Ratings"
          },
          {
            action: "extension",
            title: "Footer",
            name: "footer",
            group: "pages"
          },

          {
            action: "assessment",
            title: "Images",
            name: "images",
            group: "pages"
          },
          {
            action: "assignment_ind",
            title: "Sparkline",
            name: "sparkline",
            group: "pages"
          },
          {
            action: "fingerprint",
            title: "Hover",
            name: "hover",
            group: "pages"
          },
          {
            action: "fingerprint",
            title: "Grids",
            name: "grids",
            group: "pages"
          },
          {
            title: "Loader",
            name: "loader",
            group: "pages",
            color: "teal"
          },
          {
            title: "Navigation Drawer",
            name: "navigation-drawer",
            group: "pages",
            color: "teal"
          },
          {
            title: "Parallax",
            name: "parallax",
            group: "pages",
            color: "teal"
          }
        ],
        groups: [
          {
            action: "airplay",
            title: "Buttons",
            name: "buttons-groups",
            group: "groups",
            color: "green"
          },
          {
            action: "speed",
            title: "Chips",
            name: "chips-groups",
            group: "groups"
          },
          {
            action: "call",
            title: "Items",
            name: "items-groups",
            group: "groups"
          },
          {
            action: "contact_mail",
            title: "List",
            name: "list-groups",
            group: "groups"
          },
          {
            action: "contacts",
            title: "Slides",
            name: "slide-groups",
            group: "groups"
          },
          {
            action: "import_contacts",
            title: "Windows",
            name: "windows",
            group: "groups"
          },
          {
            action: "brightness_medium",
            title: "Colors",
            name: "colors-groups",
            group: "groups"
          },
          {
            action: "insert_invitation",
            title: "Date Pickers",
            name: "date-groups",
            group: "groups"
          },
          {
            action: "access_alarm",
            title: "Time Pickers",
            name: "time-groups",
            group: "groups"
          }
        ],
        icons: [
          {
            name: "fontawesome",
            group: "icons",
            action: "mdi-diamond-stone",
            title: "FontAwesome"
          },

          {
            name: "themify",
            group: "icons",
            action: "mdi-dice-2",
            title: "Themify"
          },

          {
            name: "ion",
            group: "icons",
            action: "mdi-dna",
            title: "Ion"
          },

          {
            name: "simpleline",
            group: "icons",
            action: "mdi-disqus-outline",
            title: " Simpleline"
          },

          {
            name: "material",
            group: "icons",
            action: "mdi-moon-waxing-crescent",
            title: " Material"
          }
        ],
        tables: [
          {
            name: "table-basic",
            title: "Basic",
            action: "loyalty",
            group: "tables"
          },
          {
            name: "datatable",
            title: "Data Table",

            group: "tables"
          },
          {
            name: "data-iterators",
            title: "Data Iterators",
            group: "tables"
          }
        ],

        widgets: [
          {
            name: "widgets1",
            title: "Widgets 1",
            action: "ti-palette",
            group: "widgets"
          },

          {
            name: "widgets2",
            title: "Widgets 2",
            action: "mdi-odnoklassniki",
            group: "widgets"
          }
        ],
        session: [
          {
            action: "apps",
            title: "Blank",
            name: "blank",
            color: "red",
            group: "session"
          },
          {
            action: "mdi-paperclip",
            title: "Home",
            name: "home",
            group: "session"
          },
          {
            action: "https",
            title: "Login",
            name: "login",
            group: "session"
          },

          {
            action: "input",
            title: "Register",
            name: "register",
            group: "session"
          },
          {
            action: "input",
            title: "Lockscreen",
            name: "lock-screen",
            group: "session"
          },
          {
            action: "input",
            title: "Forgot Password",
            name: "forgot-password",
            group: "session"
          },
          {
            action: "explicit",
            title: "Error403",
            name: "error403",
            color: "red",
            group: "error"
          },
          {
            title: "Error404",
            name: "error404",
            color: "red",
            group: "error"
          },
          {
            action: "explicit",
            title: "Error505",
            name: "error505",
            color: "red",
            group: "error"
          }
        ]
      }
    };
  },
  methods: {
    goGroup(x, y) {
      let vm = this;
      vm.$router.push(`/${x}/${y}`);
    },
    goPage(x, y) {
      let vm = this;
      vm.$router.push(`/${x}/${y}`);
    }
  }
};
</script>
<style scoped>
/* APPDRAWER */
#appDrawer {
  height: 100% !important;
  top: 0px;
  width: 300px;
}

.app-drawer__left {
  text-align: center;

  padding: -20px;
  width: 80px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden !important;
}

.app-drawer__logo-left {
  padding-top: -20px;
  margin-top: -20px;
}

.appDrawer__logo img {
  width: 200px;
  margin-top: 20px !important;
  padding-top: 10px;
  margin-bottom: 10px;
}

.apo-drawer__top {
  padding: 3px;
}

.app-drawer__name {
  text-align: center;
  color: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;

  cursor: pointer;
}

.appDrawer__left {
  list-style: none;
  text-align: center;
  position: fixed;
  padding-top: 16px;
  width: 80px;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden !important;
}

.appDrawer__left i {
  font-size: 18px;
}

.apoDrawer__top {
  padding: 3px;
}

.appDrawer__name {
  text-align: center;
  color: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;

  cursor: pointer;
}

.appDrawer__lefttitle {
  font-size: 0.71rem;
}

.appDrawer__leftItem {
  position: relative;
  width: 100%;
  color: #fff;
  padding: 10px 0;

  cursor: pointer;
  border-bottom: 1px solid rgba(177, 165, 165, 0.247);
}

.appDrawer__leftItem i {
  font-size: 24px !important;
}

.appDrawer__leftItem.active {
  color: #fff;
  border-left: 1px solid #f9f9f9;
}

.appDrawer__leftname {
  text-align: center;
  font-size: 0.5rem;
}

.appDrawer__appName img {
  padding: 15px 0 25px 0px;
  margin-top: 10px;
  margin-left: 10px;
  width: 160px;
}
.title-logo {
  margin-left: 50px;
  margin-top: -40px;
}

.appDrawer__lefttitle {
  text-align: center !important;
}

.appDrawer__leftItem.active:after {
  content: " ";
  width: 10px;
  height: 10px;
  position: absolute;
  margin-left: 35px;
  background: #fff;
  transform: rotate(45deg);
}

.appDrawer__right {
  text-align: left;
  overflow-y: scroll;
  padding-top: 0px;
  widows: 100%;
  margin-left: 80px;
  background: #fff;
  cursor: pointer;
  height: 100% !important;
  position: relative;
}

.appDrawer__right-header {
  background: #fff;
  color: #333;
  font-family: "Poppins";
  font-weight: 700;
  font-size: 18px;
}

.appDrawer__right-title {
  background: #fff;
  color: #333;
  font-family: "Poppins";
  font-weight: 700;
  font-size: 1.1rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.child-view {
  position: absolute;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}

/* width */
::-webkit-scrollbar {
  width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: transparent;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}
</style>
<!--====  End of SIDEBARDUO  ====-->